let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lGas3")).then(() => parcelRequire('8WDlD'));